const uk = {
    9000001: "2023 Різдвяний Кубок",
    9000002: "Чемпіонат SuperEx за контрактом",
    9000003: "виграйте 30,000 USDT у конкурсному призовому фонді",
    9000004: "Кількість учасників",
    9000005: "Розблокований призовий фонд (USDT)",
    9000006: "Кваліфікаційний турнір за обсягом торгів",
    9000007: "Кваліфікаційний турнір за рейтингом прибутковості",
    9000008: "Кваліфікаційний турнір за рейтингом суми прибутку",
    9000009: `Змагання за обсягом торгів, розблокуйте призовий фонд до <span style="color: #ffc72b;">20,000</span> USDT`,
    9000010: "Розблокуйте відповідний призовий фонд відповідно до кількості учасників; чим більше учасників, тим більший призовий фонд, до 20,000 USDT",
    9000011: "Сума призового фонду",
    9000012: "Щоденне оновлення о 10:00 (UTC) під час заходу",
    9000013: "Оцінка нагород",
    9000014: "Загальний обсяг торгівлі ф'ючерсами за період",
    9000015: "Правила нагородження",
    9000016: "Розблокуйте відповідний призовий фонд відповідно до кількості учасників; чим більше учасників, тим більший призовий фонд, до 20,000 USDT",
    9000017: "Сума призового фонду (USDT)",
    9000018: "Рейтинг рентабельності діяльності",
    9000019: "Реєстрація",
    9000020: "Рейтинг за сумою прибутку заходу",
    9000021: "Закінчено",
    9000022: `Переглянути список за прибутковістю, розділити <span style="color: #ffc72b;">{moneyPond}</span> доларів у формі USDT`,
    9000023: `Змагання за рейтингом суми прибутку, розділіть призовий фонд у <span style="color: #ffc72b;">{moneyPond}</span> USDT`,
    9000024: "Рейтинг кумулятивної прибутковості ф'ючерсів",
    9000025: "Загальний ф'ючерсний прибуток",
    9000026: "Не розпочато",
    9000027: "Учасники, що займають перші 50 місць за сумою прибутку, можуть отримати нагороди, можна ознайомитися з правилами нагородження за рейтингом торгів",
    9000028: "50 користувачів з найбільшою прибутковістю можуть отримати винагороду. Щоб отримати винагороду, ви можете прочитати правила винагороди за торговельний рейтинг.",
    9000029: "Рейтинг торговельного обороту заходу",
    9000030: "Реєстрація успішна",
    9000031: "Завантажте програму",
    9000032: "На головну",

    //合约交易积分
    9100001: 'Зберегти бали',
    9100002: 'Отримати Airdrop',
    9100003: 'Обміняти винагороди',
    9100004: 'Баланс балів',
    9100005: 'Деталі',
    9100006: 'Бали за реєстрацію',
    9100007: 'Торгові бали',
    9100008: 'Бали за запрошення',
    9100009: 'Бонусні бали',
    9100010: 'Щасливий розіграш',
    9100011: 'Отримайте бали',
    9100012: 'Правила нарахування балів',
    9100013: 'Інформація про бали',
    9100014: 'Щоб взяти участь у цій події, вам потрібно зареєструватися. Натисніть, щоб зареєструватися',
    9100015: 'Ви торгували {day} днів поспіль і заробили {num} балів',
    9100016: 'Бали, зароблені сьогодні {num}.',
    9100017: 'Призовий фонд у балах',
    9100018: 'Кожен розіграш коштує {point} балів, і за день можна провести не більше {num} розіграшів.',
    9100019: 'Кількість щасливих розіграшів сьогодні',
    9100020: 'Користувач',
    9100021: 'Бали',
    9100022: 'Недостатньо балів на рахунку',
    9100023: 'На вашому рахунку недостатньо балів. Будь ласка, поповніть баланс для участі в розіграші.',
    9100024: 'Кількість розіграшів досягла свого ліміту!',
    9100025: 'Кількість розіграшів на сьогодні вичерпано. Спробуйте завтра.',
    9100026: 'Як отримати бали',
    9100027: `Зареєструйтеся для участі у ф'ючерсній торгівлі, щоб заробляти бали.`,
    9100028: 'Реєстрація успішна',
    9100029: `Ви зареєструвалися для участі в торгівлі ф'ючерсами, щоб заробити бали. Перейдіть до торгівлі, щоб заробити більше балів (ви більше не будете користуватися комісією та винагородою у вигляді кешбеку)`,
    9100030: 'Після скасування реєстрації ви більше не будете отримувати бали. Ви впевнені, що хочете скасувати реєстрацію?',
    9100031: 'Центр активності торгових балів',
    9100032: 'Отримайте бали',
    9100033: 'Щоб взяти участь у цій події, вам потрібно зареєструватися. Натисніть, щоб зареєструватися',
    9100034: `Ви можете отримувати бали безперервно, торгуючи ф'ючерсами`,
    9100035: `Користувачі можуть заробляти бали за всі операції з ф'ючерсами`,
    9100036: 'Бали в таблиці лідерів',
    9100037: `П'ять кращих користувачів у щоденному рейтингу отримають додаткові бонусні бали`,
    9100038: 'Запрошувач та запрошені користувачі отримають бонусні бали.',
    9100039: '{guy} Вже виграв <span style="color:#D9A31A"> {num} балів!</span>',
    9100040: 'Спробуйте Lucky Draw зараз!',
    9100041: 'Вітаємо з отриманням',
    9100042: 'Всі типи',
    9100043: 'Залишитися на цій сторінці',
    9100044: 'Зареєструйтесь для участі',
    9100045: 'Продовжити торгівлю',
    9100046: 'На даний момент немає проходячих подій. Будь ласка, следуйте за оновленнями...',
    9100047: 'отримуйте аірдропи та обмінюйте їх на токени SCS',
    9100048: '',
    9100049: '',

    9100050: 'Дати',
    9100051: 'Виберіть дату початку',
    9100052: 'Виберіть дату завершення',
    9100053: 'до',
    9100054: 'Тип',

    9100055: 'Зароблені бали = обсяг торгів * 1% (складність буде додатково коригуватися в міру збільшення загального обсягу торгів на платформі)',
    9100056: 'Наприклад: користувач використовує позицію з маржею 100 USDT*100X=10000 USDT',
    9100057: 'Тоді для отримання 100 балів потрібно лише депозит у розмірі 100 USDT',
    9100058: 'Торгові бали - це єдиний спосіб отримати токен платформи SCS',
    9100059: 'Додаткові бонусні бали = загальна кількість балів за день * рейтинговий коефіцієнт винагороди',
    9100060: 'Ранг',
    9100061: '1 місце',
    9100062: '2 місце',
    9100063: '3 місце',
    9100064: '4 місце',
    9100065: '5 місце',
    9100066: 'Запрошувач та запрошені користувачі отримають бонусні бали.',
    9100067: 'Коефіцієнт рівня',
    9100068: 'Формула розрахунку: отримані бали рефералів = бали, отримані запрошеним * коефіцієнт рівня',
    9100069: 'Коефіцієнт рівня буде коригуватися відповідно до фактичної ситуації',
    9100070: 'Наприклад: Користувач B бере участь в активності, що приносить бали, його запрошує Користувач A, а кількість запрошень від Користувача A досягла 3-го рівня. Користувач Б накопичив балів = 360 000;',
    9100071: 'Тоді кумулятивна кількість балів заохочення, яку може отримати користувач А = 360000*30% = 108 000',
    9100072: 'Коефіцієнт винагороди',
    9100073: '1 Торгуючих користувачів',
    9100074: 'Обсяг торгів досягає 5 мільйонів',
    9100075: 'Обсяг торгів досягає 20 мільйонів ',

    9100076: 'Переказ',

    //热币
    9100080: 'Завершено',
    9100081: 'Натисніть «Приєднатися зараз», щоб виграти винагороди',
    9100082: 'Переглянути правила',
    9100083: 'Приєднуйся зараз',
    9100084: 'Діяльність',
    9100088: 'Торгівля',
    9100089: 'депозит',
    9100090: 'Ви вже зареєстровані.',

    9100091: 'Ця подія вже завершилася, з нетерпінням чекайте наступної події!',
    9100092: `Подія ще не почалася, будь ласка, залишайтесь на зв'язку.`,
    9100093: '',
    9100094: '',
}
export default uk



// WEBPACK FOOTER //
// ./src/i18n/langs/languageJame/uk.js